import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { PageContent } from "./PageContent/FlightInformation";
import { AddEditHeader } from "./PageHeader/AddEditHeader";

export const Flightinfo = () => {
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const navigate = useNavigate();

  // Redirect to pageContent tab by default
  useEffect(() => {
    if (!activeTab) {
      navigate(`/dedicated/passenger/flight-information/?activeTab=pageHeader`, {
        replace: true,
      });
    }
  }, [activeTab, navigate]);

  // Tab structure
  const tabItems = [
    {
      label: "Page Header",
      key: "pageHeader",
      children: <AddEditHeader />,
    },
    {
      label: "Flight Card",
      key: "pageContent",
      children: <PageContent />,
    },
  ];

  // Action button handler for each tab
  // const handleActionButton = (tabKey: string) => {
  //   switch (tabKey) {
  //     // case "pageContent":
  //     //   return (
  //     //     <Button
  //     //       onClick={() =>
  //     //         navigate("/dedicated/passenger/flightinfo/flightinformation/add")
  //     //       }
  //     //       icon={<Icon icon="lucide:plus" />}
  //     //     >
  //     //       Add Flight Information
  //     //     </Button>
  //     //   );

  //     case "pageHeader":
  //       return (
  //         <Button
  //           onClick={() => navigate("/dedicated/passenger/flightinfo/pageheader/add")}
  //           icon={<Icon icon="lucide:plus" />}
  //         >
  //           Add Page Header
  //         </Button>
  //       );

  //     default:
  //       return null;
  //   }
  // };

  return (
    <ContentWrapper
      title="Flight Information"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      // actionItems={handleActionButton(activeTab || "pageContent")}
      airportText={`Airport Specific Content`}
    >
      <Tabs
        activeKey={activeTab || "pageContent"}
        items={tabItems}
        onChange={(key) => navigate(`${window.location.pathname}?activeTab=${key}`)}
      />
    </ContentWrapper>
  );
};
